import * as Yup from 'yup'

import { CHECKBOXES, EMAIL } from '../fields'
import { CAPATCHA, NUMBER } from '../fields/constants'
import { FormRecord } from '../types'
import { SELECT } from './../fields/constants'
import { getKey } from './get-key'

export const buildValidationSchema = (formRecord: FormRecord) => {
  let shape = {}
  formRecord.formSpec.fields.map((field, i) => {
    if (field.isRequied) {
      const key = getKey(i)
      if (field.type === EMAIL) {
        shape[key] = Yup.string()
          .email('To powinien być poprawny e-mail')
          .required('To pole jest wymagane')
      } else if (field.type === CHECKBOXES || field.type === SELECT) {
        if (!!field.multiple) {
          shape[key] = Yup.array()
            .min(1, 'Wybierz przynajmniej jedną opcję')
            .required('To pole jest wymagane')
        } else {
          const msg =
            field.values && field.values.length === 1
              ? 'To pole musi być zaznaczone'
              : 'Wybierz jedną opcję'
          shape[key] = Yup.string().required(msg)
        }
      } else if (field.type === NUMBER) {
        shape[key] = Yup.number()
          .min(1, 'Wpisz liczbę większą od zera')
          .required('To pole jest wymagane')
      } else if (field.type === CAPATCHA) {
        shape[key] = Yup.string().required(
          'Zaznacz kwadrat w polu powyżej (reCapatcha)',
        )
      } else {
        shape[key] = Yup.string().required('To pole jest wymagane')
      }
    }
  })

  const validationSchema = Yup.object().shape(shape)
  return validationSchema
}
